import React, { Component }
from 'react';
import { BrowserRouter as  Redirect }
from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class ChatHistoryRevision extends Component {
constructor() {
super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
        search: [],
                apiUrl: this.decryptconfigdata('apiUrl'),
                userAuthKey: has_local_data ? localdata.user_key : '',
                historyRev: [],
                er_title: ''
        };
}

decryptconfigdata(configkey) {
var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
        iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
}

decrypt(findresponse, flg) {
var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
        iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
}

rawjsonparse(findresponse, flg) {
        return findresponse;
    }

ChatHistoryRevision() {
fetch(this.state.apiUrl + '/ErRest/ChatHistoryRevision/id/' + this.props.match.params.transcriptId + '/userAuthKey/' + this.state.userAuthKey + '/noteId/' + this.props.match.params.noteId)
        .then((Response) => Response.json())
        .then((responseJson) => {
        responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                historyRev: responseJson.historyRev,
                })
        })
}

goBack() {
window.location.href = '/EditChat/' + this.props.match.params.transcriptId;
}

componentDidMount() {
document.title = "Intranet | History Revision";
        this.ChatHistoryRevision();
}

render() {
if (this.state.redirect) {
return (
<Redirect to={'/login'} />
        )
}
return (
<div >
    <Header brecum_name="Chat History Revision" brecum_page="Chat History Revision" />
    <div class="right_col">
        <div className="intranet_body">
            <div class="title mob"><HeaderMob page_name="Chat History Revision" /></div>
            <label></label>
            {/*loop start for revision  */}
            {
        this.state.historyRev.map((ChatHistory, key) =>
            <div>
                <div class="row">
                    <div class="col-md-3 col-xs-12"><b>Revision </b></div>
                    <div class="col-md-6 col-xs-12">{ChatHistory.created_date} by {ChatHistory.user_name}</div>
                </div>
                <br />
                <div class="row">
                    <div class="col-md-3 col-xs-12"><b>{ChatHistory.type == 1 ? 'Description' : (ChatHistory.type == 4 ? 'Note' : '')}</b></div>
                    <div class="details_des col-md-6"><div dangerouslySetInnerHTML={{ __html: ChatHistory.value }} /></div>
                </div>
                <div class="row">
                    <hr></hr>
                </div>
            </div>
                )
            }

            {/* loop end for revision  */}
            <div class="top-row border-bottom hidden-xs">
                <button type="button" className="btn btn-blue" onClick={() => this.goBack()} >Back</button>
            </div>
        </div>
    </div>
</div>
                );
        }
        }

        export default ChatHistoryRevision;


// WEBPACK FOOTER //
// ./src/components/er/ChatHistoryRevision.js